// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Dn3IOwkAxXG4ks {
  display: inline-flex;
  margin-bottom: var(--ds-space-0, 0);
  padding: var(--ds-space-050, 4px);
  border: none;
  border-radius: var(--ds-border-radius-100, 3px);
  background-color: var(--ds-background-discovery-bold, #6e5dc6);
  color: var(--ds-text-inverse, #ffffff);
  font-size: 12px;
  line-height: 12px;
  text-decoration: none;
}
.Dn3IOwkAxXG4ks .JyEAiVtmLzGPji svg {
  color: var(--ds-icon-inverse, #ffffff);
}
.Dn3IOwkAxXG4ks:hover {
  background-color: var(--ds-background-discovery-bold-hovered, #583f68);
  color: var(--ds-text-inverse, #ffffff);
}
.JyEAiVtmLzGPji {
  display: flex;
  justify-content: center;
  width: 12px;
  height: 12px;
  margin-right: var(--ds-space-050, 4px);
  line-height: 12px;
}
.JyEAiVtmLzGPji > span {
  width: 12px;
  height: 12px;
}
`, ""]);
// Exports
export var upgradePromptPill = `Dn3IOwkAxXG4ks`;
export var upgradePromptPillIcon = `JyEAiVtmLzGPji`;
export default ___CSS_LOADER_EXPORT___;
